import { Box, Flex, Grid } from '@chakra-ui/react';
import { Color } from 'src/theme/color';

export const LeftColumn = ({ children }: any) => {
	return (
		<Grid
			p="83px 60px 50px 0px"
			justifySelf="flex-end"
			w="620px"
		>
			<Flex flexDir="column">{children}</Flex>
		</Grid>
	);
};
